import styled from 'styled-components';
import { List, textStyles, token } from '@bynder/design-system';

export const ImportContainer = styled.div`
    display: flex;
    justify-content: center;
    flex: 1;
    padding: ${token.spacing7};
    overflow: auto;
`;

export const ImportInner = styled.div`
    display: flex;
    flex-flow: column nowrap;
    width: 664px;
    align-self: flex-start;
    text-align: center;
    padding: ${token.spacing2};
    align-items: center;
    & hr {
        width: 100%;
    }
    & table {
        margin-bottom: ${token.spacing4};
    }
`;

const getImportStatus = ({ $importStatus, importStatus }: { $importStatus?: boolean; importStatus?: boolean }) =>
    $importStatus ?? importStatus;

export const IconContainer = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'importStatus',
})<{ $importStatus?: boolean; importStatus?: boolean }>`
    align-self: center;
    height: 128px;
    width: 128px;
    border-radius: 50%;
    background-color: ${(props) => {
        const importStatus = getImportStatus(props);

        if (importStatus === undefined) {
            return token.gray25;
        }

        return importStatus ? token.blue500a10 : token.red500a10;
    }};
    display: flex;
    align-items: center;
    justify-content: center;
    > svg {
        fill: ${(props) => {
            const importStatus = getImportStatus(props);

            if (importStatus === undefined) {
                return token.gray400;
            }

            return importStatus ? token.blue500 : token.red500;
        }};
        width: 40px;
        height: auto;
        max-height: 40px;
    }
`;

export const Title = styled.div`
    ${textStyles.headingM}
    color: ${token.gray1000};
    word-break: break-word;
    margin-top: ${token.spacing6};
    margin-bottom: ${token.spacing6};
`;

export const AdditionalInfo = styled.div`
    margin-top: ${token.spacing4};
    margin-bottom: calc(${token.spacing6} + 4px);
    display: flex;
    width: 472px;
    justify-content: center;
    color: ${token.gray600};
`;

export const XMLInfo = styled.p`
    color: ${token.gray600};
`;

export const FileImportColumn = styled.div`
    flex-wrap: wrap;
    margin-top: ${token.spacing2};
    display: flex;
    width: 472px;
    justify-content: center;
`;

export const FileImportColumnTitle = styled.div`
    ${textStyles.paragraphM}
    color: ${token.gray800};
    width: 100%;
    text-align: center;
    margin-top: ${token.spacing4};
`;

export const FileImportListItem = styled(List.Item)`
    ${textStyles.paragraphM}
    color: ${token.gray800};
    margin: ${token.spacing2} 0;
    text-align: left;
    justify-content: flex-start;
    padding: 0;

    & > div {
        line-height: inherit !important;
    }

    & > div:first-child {
        height: 24px;
        margin-right: ${token.spacing2};

        div {
            height: 20px;

            svg {
                vertical-align: unset !important;
            }
        }
    }
`;

export const StyledTableCell = styled.td`
    text-align: left;
    width: 50%;
    padding: 0 0 0 6px;
`;

export const StyledTableTitle = styled(StyledTableCell)`
    text-align: right;
    padding: 0 6px 0 0;
`;

export const FileImportListItemTitle = styled(FileImportListItem)`
    ${textStyles.paragraphM}
    color: ${token.gray600};
    text-align: right;
    justify-content: flex-end;
    padding: 0;
    max-width: 220px;
`;

export const ProgressContainer = styled.div`
    width: 224px;
`;

export const StyledIcon = styled.div`
    display: inline-block;
    margin-left: ${token.spacing3};

    & > div {
        display: inline-block;
    }
`;

export const UploadButtons = styled.div`
    & > :first-child {
        margin-right: ${token.spacing3};
    }
    margin-bottom: ${token.spacing6};
`;

export const DropdownContainer = styled.div`
    padding: ${token.spacing4} 0 0 0;
`;

export const TwoColumnLayout = styled.div`
    display: flex;
    width: 100%;
    gap: 64px;
    text-align: left;
    margin-top: ${token.spacing4};
`;

export const Column = styled.div`
    flex: 1;
    min-width: 300px;
    max-width: 50%;
`;

export const ColumnHeader = styled.div`
    ${textStyles.headingS}
    color: ${token.gray800};
    margin: 8px 0;
    padding: 8px 0 12px 0;
`;

export const DetailsGroup = styled.div`
    margin: 8px 0;
    padding: 8px 0;
`;

export const DetailLabel = styled.span`
    color: ${token.gray600};
`;

export const DetailValue = styled.span`
    color: ${token.gray800};
    font-weight: 500;
    white-space: nowrap;
`;

export const DropdownLabel = styled.div`
    ${textStyles.paragraphM}
    color: ${token.gray600};
    margin-bottom: ${token.spacing2};
`;

export const DropdownSection = styled.div`
    margin: 8px 0;
    padding: 8px 0;
`;

export const PagesGroup = styled.div`
    margin: 8px 0;
    padding: 8px 0;
`;

export const PageItem = styled.div`
    ${textStyles.paragraphM}
    color: ${token.gray800};
    display: flex;
    align-items: center;
    gap: ${token.spacing2};
`;

export const ImportTable = styled.table`
    border-collapse: collapse;

    th {
        text-align: inherit;
    }
`;
